import { createActionCreators, createReducerFunction, ImmerReducer } from 'immer-reducer';
import { IItemLookup } from '../../interfaces/dtos/IItemLookup';
import { ITareWeightGroupState } from '../../interfaces/states/ITareWeightGroupsState';

const initialState: ITareWeightGroupState = {};

class TareWeightGroupsReducer extends ImmerReducer<ITareWeightGroupState> {
  public addTareWeightGroup(
    itemId: string,
    linkedItems: IItemLookup[],
    isManualTarePercentageEnabled?: boolean,
  ): void {
    if (!this.draftState[itemId]) {
      this.draftState[itemId] = { linkedItems, isManualTarePercentageEnabled };
    }
  }

  public resetTareWeightGroups() {
    this.draftState = initialState;
  }
}

export const TareWeightGroupsActions = createActionCreators(TareWeightGroupsReducer);
export const TareWeightGroupsReducerFunction = createReducerFunction(
  TareWeightGroupsReducer,
  initialState,
);
